import React, { useState } from 'react';
import { IconButton, Badge } from '@mui/material';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { useMedicationCart } from '../../contexts/MedicationCartContext';
import { CartDrawer } from './CartDrawer';

export const CartButton: React.FC = () => {
  const { itemCount } = useMedicationCart();
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton color="inherit" aria-label="Abrir carrito" onClick={() => setOpen(true)}>
        <Badge badgeContent={itemCount} color="primary" overlap="circular">
          <ShoppingCartOutlinedIcon />
        </Badge>
      </IconButton>
      <CartDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
};
